import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {ColorFill} from '@Components/color-fill';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {getColorFillColors} from '@Components/color-fill/color-fill.util';
import {GradientStopSwatches} from '@Components/color-picker-v2/components/gradient-stop-swatches/gradient-stop-swatches';
import {GRADIENT_STYLE_TEST_IDS, GRADIENT_STYLE_TYPES, GRADIENT_SWATCH_SIZE} from './gradient-style-section.types';
import type {GradientStyleSectionProps} from './gradient-style-section.types';

/** The popup layout's gradient controls: the style swatches (linear / radial) and one swatch per colour stop. */
export function GradientStyleSection(props: GradientStyleSectionProps): ReactElement {
  const getStyleSwatch = (styleType: ColorFillPropertyType): ReactElement => {
    return (
      <ColorFill
        key={styleType}
        testId={GRADIENT_STYLE_TEST_IDS[styleType]}
        color={getColorFillColors(props.color)}
        colorFillPropertyType={styleType}
        width={GRADIENT_SWATCH_SIZE}
        height={GRADIENT_SWATCH_SIZE}
        isSelected={styleType === props.type}
        onClick={(): void => {
          props.onChangeType(styleType);
        }}
      />
    );
  };

  return (
    <div className="flex-v-row gap-4 spacing-m-b-4">
      <div className="flex-v-row gap-2">
        <Text val={window.i18next.t('pmwjs_style')} size={TextSize.MD} />
        <div className="flex-h-row gap-3">{GRADIENT_STYLE_TYPES.map(getStyleSwatch)}</div>
      </div>
      <GradientStopSwatches color={props.color} selectedColorId={props.selectedColorId} onChangeSelectedColor={props.onChangeSelectedColor} />
    </div>
  );
}
